module.exports = __webpack_public_path__ + "media/src/users/email_inbox-f3cd80938565fac1686e603dc10c05be.png";